import React from 'react';
import { ISVGType } from './SVGType';

const TransactionIcon = (props: ISVGType) => {
  const { height = 42, width = 42 } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 42 42"
      fill="none"
    >
      <rect opacity="0.3" width="42" height="42" rx="10" fill="#DD8E33" fillOpacity="0.384314" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M31 22.9072V15L23.0928 15L23.0928 16.845L27.8371 16.845L21.7749 22.9072L23.0928 24.2251L29.155 18.1629V22.9072H31ZM11 20.0024V27.9096H18.9072V26.0646H14.1629L20.2251 20.0024L18.9072 18.6845L12.845 24.7467V20.0024H11Z"
        fill="#DD8E33"
      />
    </svg>
  );
};

export default TransactionIcon;
